/**
 * CONFIGURACION DEL MENU
*/

import React, {Component} from 'react';
import Logo from './assets/images/logo_mccann.png'


class NavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
        menuOpen: false, // Estado para abrir/cerrar menú
        submenuOpen: false, // Estado para abrir/cerrar submenu
    }
  }

  toggleMenu = () => {
    this.setState({ menuOpen: !this.state.menuOpen });
  };

  toggleSubmenu = () => {
    this.setState({ submenuOpen: !this.state.submenuOpen });
  };

  render() {
    

    return (
        <div className='container-fluid bg-black'>
        <nav className="navbar">
            <div className="hamburger" onClick={this.toggleMenu}>
            ☰
            </div>
            <a href='/'><img src={Logo} alt="logo" className='logo'/></a>
            <ul className={`menu ${this.state.menuOpen ? "active" : ""}`}>
            <li>
                <a href="#">ARQUIVOS</a>
                <ul className="submenu">
                    <li><a href="/identidade-visual">IDENTIDADE VISUAL</a></li>
                    <li><a href="/logos-clientes" >Logos Clientes</a></li>
                    <li><a href="/presentaciones" >Apresentações</a></li>
                    <li><a href="/cases" >Cases</a></li>
                    {/* <li>
                        <a href="#">CASES</a>
                        <ul className="submenu">
                            <li><a href="#">CASE 1</a></li>
                            <li><a href="#">CASE 2</a></li>
                            <li><a href="#">CASE 3</a></li>
                        </ul>
                    </li> */}
                </ul>
            </li>
            <li>
                <a href="#">BENEFICIOS</a>
                <ul className="submenu">
                    <li><a href="/saude">Saúde</a></li>
                    <li> <a href="/vida">Vida</a></li>
                    <li>
                        <a href="#">Outros</a>
                        <ul className={`submenu ${this.state.submenuOpen ? "active" : ""}`}>
                            <li><a href="/convenios-academia">Academia</a></li>
                            <li><a href="/day-off">DayOff</a></li>
                            <li><a href="/educacion" >Educação</a></li>
                            <li><a href="/parcerias">Parcerias</a></li>
                            <li><a href="/restaurantes">Restaurantes</a></li>
                        </ul>
                    </li> 
                </ul>
            </li>
            <li>
                <a href="#">DIRETRIZES</a>
                <ul className="submenu">
                    <li><a href="/calendario-oficial">Calendario Oficial</a></li>
                    <li>
                        <a href="#">Politicas</a>
                        <ul className={`submenu ${this.state.submenuOpen ? "active" : ""}`}>
                            <li><a href="/politicas-administrativo">Administrativo</a></li>
                            <li><a href="/politicas-financeiro">Financeiro</a></li>
                            <li><a href="/politicas-rh">RH</a></li>
                            <li><a href="/politicas-ti">TI</a></li>
                            <li><a href="/ipg">IPG</a></li>
                        </ul>
                    </li>

                    <li>
                        <a href="#">Procedimentos</a>
                        <ul className={`submenu ${this.state.submenuOpen ? "active" : ""}`}>
                            <li><a href='/procedimientos-administrativo'>Administrativo</a></li>
                            <li><a href='/procedimientos-financeiro'>Financeiro</a></li>
                            <li><a href='/procedimientos-rh'>RH</a></li>
                            <li><a href='/procedimientos-ti'>TI</a></li>
                            <li><a href='/c-corporativa'>Comunicação Corporativa</a></li>
                        </ul>
                    </li>                   
                    <li><a href="/saude-seguran">Saúde e Segurança</a></li>
                    <li>
                        <a href="#">FAQ</a>
                        <ul className={`submenu ${this.state.submenuOpen ? "active" : ""}`}>
                            <li><a href='/faq_financeiro'>Financeiro</a></li>
                        </ul>
                    </li> 
                </ul>
            </li>
            <li>
                <a href="#">FERRAMENTAS</a>
                <ul className="submenu">
                    <li><a href="/entendam-cada-uma" >Entendam cada uma</a></li>
                    <li><a href="https://programmatic.wmccann.com/" rel="noopener noreferrer" target="_blank">Mídia Programática</a></li>
                    <li>
                        <a href="#">Estratégia</a>
                        <ul className={`submenu ${this.state.submenuOpen ? "active" : ""}`}>
                            <li><a href="https://truth2meaning.wmccann.com/" target="_blank" >Truth to meaning</a></li>
                        </ul>
                    </li>
                    <li>
                        <a href="#">FAQ Ferramentas</a>
                        <ul className={`submenu ${this.state.submenuOpen ? "active" : ""}`}>
                            <li><a href='/faq_suporte'>FAQ Suporte</a></li>
                            <li><a href='/faq_skills'>FAQ Skills</a></li>
                            <li><a href='/faq_adsolutions'>FAQ AdSolutions</a></li>
                        </ul>
                    </li>  
                </ul>
            </li>
            <li>
                <a href="#">NOTÍCIAS</a>
                <ul className="submenu">
                    <li><a href="/comunicacao-interna" >Comunicação Interna</a></li>
                    <li><a href="/comunicacao-externa" >Comunicação Externa</a></li>
                    <li>
                        <a href="#">Internacional</a>
                        <ul className={`submenu ${this.state.submenuOpen ? "active" : ""}`}>
                            <li><a href="https://interpublic.sharepoint.com/sites/MWG-InsideLatam_PORT" target="_blank" rel="noopener noreferrer">INSIDE LATAM</a></li>
                            <li><a href="https://inside.mccannwg.com/" target="_blank" rel="noopener noreferrer">INSIDE WG</a></li>
                            <li><a href="https://inside.interpublic.com/" target="_blank" rel="noopener noreferrer">NSIDE INTERPUBLIC</a></li>
                        </ul>
                    </li> 
                </ul>
            </li>
            <li>
                <a href="#">PESSOAS</a>
                <ul className="submenu">
                <li><a href="/diversidad">Diversidade e Inclusão </a></li>
                <li><a href="https://secure.ethicspoint.com/domain/media/en/gui/56941/index.html"rel="noopener noreferrer" target="_blank">Alert Line</a></li>
                <li><a href="https://mwtransitions-redcarpet.silkroad.com/pl"rel="noopener noreferrer" target="_blank">Perfomance Coaching</a></li>
                <li><a href="https://adp.interpublic.com/" target="_blank"rel="noopener noreferrer">Portal do Colaborador</a></li>
                <li><a href="https://interpublic.sharepoint.com/sites/TalentWise" target="_blank"rel="noopener noreferrer">Talent Wize</a></li>
                <li><a href="/pessoas-treinamento"rel="noopener noreferrer">Treinamentos </a></li>
                <li><a href="https://mccannwg.avature.net/en_US/careersinternal"rel="noopener noreferrer" target="_blank">Vagas</a></li>
                </ul>
            </li>
        </ul>
        <a href="mailto:rh.brasil@wmccann.com"  className="contact-button"> <i className="fa-solid fa-arrow-right"></i>&nbsp;&nbsp; FALE CONOSCO &nbsp;&nbsp;<i className="fa-regular fa-envelope"></i> </a>
        </nav>
    </div>
    );
    }
}

export default NavBar;